import AppImages from "../assets/AppImages";
import DashboardHome from "../pages/Dashboard/Home";
import DashboardNone from "../pages/Dashboard/None";
import DashboardVehicleInventory from "../pages/Dashboard/Vehicle/Inventory";
import { DashboardVehicleInventoryDetails } from "../pages/Dashboard/Vehicle/Details";
import DashboardTradeInForm from "../pages/Dashboard/TradeInForm";
import DashboardVehicleDelivery from "../pages/Dashboard/Vehicle/Delivery";
import DashboardVehicleNew from "../pages/Dashboard/Vehicle/New";
import DashboardProfile from "../pages/Dashboard/Profile";
import DashboardEmployees from "../pages/Dashboard/Employees";
import DashboardClients from "../pages/Dashboard/Clients";
import DashboardPreQualifyInquiry from "../pages/Dashboard/PreQualifyInquiry";
import DashboardVehiclePurchaseInventory from "../pages/Dashboard/Vehicle/PurchaseInventory";
import DashboardTalkToExpertInquiry from "../pages/Dashboard/TalkToExpertInquiry";

export interface DashboardPage {
    link: string;
    title: string;
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
    adminOnly?: boolean;
    subOnly?: boolean;
    child?: DashboardPage[];
    component: React.FC;
    hidden?: boolean;
    showToRoles?: string[];
}

export const dashboard_pages: DashboardPage[][] = [
    [
        {
            hidden: true,
            title: "Home",
            link: "home",
            icon: AppImages.IconHome,
            component: DashboardHome,
            showToRoles: ["SuperUser", "Admin"],
        },
        {
            title: "Vehicles",
            link: "vehicles",
            icon: AppImages.IconVehicles,
            component: DashboardNone,
            child: [
                {
                    title: "Inventory",
                    link: "vehicles/inventory",
                    icon: AppImages.IconVehicles,
                    component: DashboardVehicleInventory,
                },
                {
                    title: "New Vehicle",
                    link: "vehicles/new",
                    icon: AppImages.IconVehicles,
                    component: DashboardVehicleNew,
                    hidden: true,
                },
                {
                    title: "Details",
                    link: "vehicles/inventory/:vin",
                    icon: AppImages.IconVehicles,
                    component: DashboardVehicleInventoryDetails,
                    hidden: true,
                },
                {
                    title: "Deliveries",
                    link: "vehicles/deliveries",
                    icon: AppImages.IconVehicles,
                    component: DashboardVehicleDelivery,
                    showToRoles: ["SuperUser", "Admin", "Mechanic", "Parts Analyst"],
                },
            ],
        },
        {
            title: "Profile",
            link: "profile",
            hidden: true,
            icon: AppImages.IconSelling,
            component: DashboardProfile,
        },
        {
            hidden: true,
            title: "Settings",
            link: "settings",
            icon: AppImages.IconSelling,
            component: DashboardNone,
        },
        {
            title: "Clients",
            link: "clients",
            icon: AppImages.IconEmployees,
            component: DashboardClients,
            showToRoles: ["SuperUser", "Admin"],
        },
        {
            title: "Employees",
            link: "employees",
            icon: AppImages.IconEmployees,
            component: DashboardEmployees,
            showToRoles: ["SuperUser", "Admin"],
        },
        //{ title: 'Employee', link: 'employees/:id', icon: AppImages.IconEmployees, component: DashboardEmployeeDetails, hidden: true, },
        {
            hidden: true,
            title: "Payouts",
            link: "payouts",
            icon: AppImages.IconParts,
            component: DashboardNone,
        },
        {
            title: "Purchase Inventory",
            link: "purchase-inventory",
            icon: AppImages.IconPurchaseInventory,
            component: DashboardVehiclePurchaseInventory,
            showToRoles: ["SuperUser", "Admin"],
        },
        {
            hidden: true,
            title: "Locations",
            link: "locations",
            icon: AppImages.IconLocations,
            component: DashboardNone,
        },
        {
            hidden: true,
            title: "Selling",
            link: "selling",
            icon: AppImages.IconSelling,
            component: DashboardNone,
        },
        {
            hidden: true,
            title: "Reports & Stats",
            link: "reports-stats",
            icon: AppImages.IconReports,
            component: DashboardNone,
            showToRoles: ["SuperUser", "Admin"],
        },
        {
            title: "Trade-In Requests",
            link: "trade-in",
            icon: AppImages.IconSelling,
            component: DashboardTradeInForm,
            showToRoles: ["SuperUser", "Admin"],
        },
        {
            title: "Pre-Qualify Inquiry",
            link: "pre-qualify-inquiry",
            icon: AppImages.IconReports,
            component: DashboardPreQualifyInquiry,
            showToRoles: ["SuperUser", "Admin"],
        },
        {
            title: "Talk to Expert Inquiries",
            link: "talk-to-expert-inquiry",
            icon: AppImages.IconReports,
            component: DashboardTalkToExpertInquiry,
            showToRoles: ["SuperUser", "Admin"],
        },
    ],
    [
        {
            title: "Help & Support",
            link: "help",
            icon: AppImages.IconHelp,
            component: DashboardNone,
        },
        {
            title: "Sign Out",
            link: "signout",
            icon: AppImages.IconSignout,
            component: DashboardNone,
        },
    ],
];

function findDashboardPageByLink(link: string, pages: DashboardPage[]): DashboardPage | undefined {
    for (const page of pages) {
        if (page.link === link) {
            return page;
        }
        // Check if the current page has children and search recursively
        if (page.child) {
            const childResult = findDashboardPageByLink(link, page.child);
            if (childResult) {
                return childResult;
            }
        }
    }
    return undefined;
}

export function find_page(link: string): DashboardPage | undefined {
    for (const group of dashboard_pages) {
        const result = findDashboardPageByLink(link, group);
        if (result) {
            return result;
        }
    }

    return dashboard_pages[0][0];
}